import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class ReportAPI {

  static list = (success, failure) => {
    fetch(Config.app.link + 'api/report', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/report/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (report, success, failure) => {
    fetch(Config.app.link + 'api/report/add-edit', new Header('POST', report))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static data = (id, filter, success, failure) => {
    fetch(Config.app.link + 'api/report/data/' + id, new Header('POST', { filter }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static reportData = (type, model, x, y, z, filter, success, failure) => {
    fetch(Config.app.link + 'api/report/data', new Header('POST', { type, model, x, y, z, filter }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static updatePermssion = (report, success, failure) => {
    fetch(Config.app.link + 'api/report/permission', new Header('POST', report))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static copy = (id, success, failure) => {
    fetch(Config.app.link + 'api/report/copy/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/report/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default ReportAPI;